<ngx-spinner
    name="managementSpinner"
    color="#fff"
    size="medium"
    type="ball-clip-rotate-multiple">
    <p class="text-xl text-white mt-4">Creating Skin...</p>
</ngx-spinner>

<div class="sm:absolute pt-2 px-4 sm:px-6 sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">

    <!-- Header -->
    <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-6 px-4 md:px-8 border-b">
        <!-- Title -->
        <div class="text-3xl md:text-4xl font-extrabold tracking-tight">Skin Destination Mapping</div>

        <!-- Actions -->
        <div class="flex flex-col sm:flex-row shrink-0 items-start sm:items-center mt-4 sm:mt-0 sm:ml-4 gap-4">
            <!-- Search by Keyword -->
            <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full sm:min-w-64"
                            *ngIf="!displayAddSkin"
                            [subscriptSizing]="'dynamic'">
                <mat-icon
                    class="icon-size-5"
                    matPrefix
                    [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
                <input
                    matInput
                    (keyup)="onKeyup()"
                    [formControl]="inputSearchControl"
                    [autocomplete]="'off'"
                    [placeholder]="'Search for keyword'">
            </mat-form-field>
            <!-- Add Destination button -->
            <button
                *ngIf="!displayAddSkin"
                class="w-full sm:w-auto"
                mat-stroked-button
                [color]="'primary'"
                (click)="toggleAddSkin()">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1">Add New</span>
            </button>
        </div>
    </div>

    <!-- Main -->
    <div class="flex flex-auto overflow-hidden">

        <!-- Elements list -->
        <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto" *ngIf="!displayAddSkin">

            <div class="flex flex-col flex-auto">
                <!-- Header Grid -->
                <div class="hidden sm:flex items-center w-full py-4 px-6 md:px-8 bg-gray-50 dark:bg-black/20 text-sm font-semibold text-secondary uppercase tracking-wider border-b sticky top-0 z-10">
                    <div class="flex flex-col flex-1 truncate">Skin Information</div>
                    <div class="flex items-center justify-end">Actions</div>
                </div>

                <!-- Rows -->
                <ng-container *ngIf="tableElementsArray.length > 0; else noProducts">
                    <ng-container *ngFor="let elementTable of tableElementsArray">

                        <!-- List Row -->
                        <div class="flex flex-col sm:flex-row sm:items-center py-4 px-6 md:px-8 border-b hover:bg-gray-50 dark:hover:bg-hover transition-colors">

                            <!-- Mobile-friendly stacked info -->
                            <div class="flex flex-col flex-1 w-full sm:w-0 truncate">
                                <span class="font-semibold text-lg sm:text-base text-default">{{ elementTable.ds_airline }}</span>
                                <span class="text-sm font-mono text-secondary mt-0.5">ID: {{ elementTable.id_airline }}</span>
                            </div>

                            <!-- Details Toggle -->
                            <div class="flex items-center justify-end mt-4 sm:mt-0 sm:ml-4">
                                <button
                                    class="relative flex items-center justify-center w-10 h-10 overflow-hidden"
                                    mat-stroked-button
                                    (click)="toggleDetails(elementTable.id_airline, 'id_airline')">
                                    <mat-icon
                                        class="icon-size-5"
                                        [svgIcon]="selectedElement?.id_airline === elementTable.id_airline ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down'"></mat-icon>
                                </button>
                            </div>
                        </div>

                        <!-- Details Sub-Panel -->
                        <div class="w-full">
                            <ng-container *ngIf="selectedElement?.id_airline === elementTable.id_airline">
                                <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: elementTable}"></ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #noProducts>
                    <div class="p-8 sm:p-16 border-t text-2xl font-semibold tracking-tight text-center text-secondary">
                        <ngx-spinner
                            bdColor="rgba(51,51,51,0)"
                            color="#fff"
                            size="medium"
                            type="ball-clip-rotate-multiple">
                            <p class="text-xl text-secondary mt-4">Loading...</p>
                        </ngx-spinner>
                        <span *ngIf="!isLoading">No results found!</span>
                    </div>
                </ng-template>
            </div>

            <mat-paginator
                class="sm:absolute sm:inset-x-0 sm:bottom-0 border-b sm:border-t sm:border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                (page)="searchElements('paginator')"
                [length]="20"
                [pageIndex]="0"
                [pageSize]="20"
                [pageSizeOptions]="[5, 10, 20, 100]"
                [showFirstLastButtons]="true">
            </mat-paginator>

            <!-- Expanded Details Template -->
            <ng-template #rowDetailsTemplate>
                <div class="shadow-inner bg-gray-50/50 dark:bg-black/10 overflow-hidden border-b border-gray-200 dark:border-gray-800">
                    <form class="flex flex-col lg:flex-row w-full gap-8 p-6 md:p-8" [formGroup]="selectedStoryTypeForm">

                        <!-- Left Column: Skin Details & Add Destination -->
                        <div class="flex flex-col w-full lg:w-1/2 gap-4">
                            <h3 class="text-lg font-bold mb-2">Skin Information</h3>

                            <mat-form-field class="w-full">
                                <mat-label>Skin Name</mat-label>
                                <input matInput [formControlName]="'ds_name'" readonly>
                            </mat-form-field>

                            <mat-form-field class="w-full">
                                <mat-label>Skin ID</mat-label>
                                <input class="font-mono text-secondary" matInput [formControlName]="'eleKey'" readonly>
                            </mat-form-field>

                            <div class="flex flex-col gap-3 mt-4">
                                <h3 class="text-lg font-bold flex items-center">
                                    Map New Destination
                                    <mat-icon svgIcon="heroicons_outline:information-circle" class="ml-2 icon-size-5 text-secondary" matTooltip="Search for a destination to map to this skin."></mat-icon>
                                </h3>

                                <div class="flex flex-col sm:flex-row items-start gap-4">
                                    <mat-form-field class="flex-grow w-full" floatLabel="always">
                                        <mat-label>Search Destination</mat-label>
                                        <input type="text"
                                               placeholder="Type name, ID or state..."
                                               (blur)="onBlur()"
                                               (keyup)="onKeyupAutoSearch($event)"
                                               matInput [formControl]="parentControl"
                                               [matAutocomplete]="auto">

                                        <mat-autocomplete
                                            requireSelection="true"
                                            (optionSelected)="optionSelected($event)"
                                            #auto="matAutocomplete"
                                            [displayWith]="displayFn"
                                            autoActiveFirstOption="true">
                                            <mat-option *ngFor="let city of filteredParents | async" [value]="city" class="h-auto py-3">
                                                <div class="flex flex-col leading-tight">
                                                    <span class="font-medium text-base">{{ city.ds_name }}
                                                        <span class="text-sm text-secondary ml-1" *ngIf="city.ds_en_state">({{city.ds_en_state}})</span>
                                                    </span>
                                                    <span class="text-sm font-mono text-secondary mt-1">ID: {{ city.id_destination }}</span>
                                                </div>
                                            </mat-option>
                                        </mat-autocomplete>

                                        <mat-error *ngIf="parentCheckerRequired && parentControl.invalid && (parentControl.touched || parentControl.dirty)">
                                            Please select a valid destination.
                                        </mat-error>
                                    </mat-form-field>

                                    <button
                                        (click)="(!parentControl.value || parentControl.invalid) ? $event.preventDefault() : addToMapList()"
                                        mat-flat-button
                                        class="w-full sm:w-auto mt-2 sm:mt-0 py-6"
                                        [color]="'primary'"
                                        [disabled]="!parentControl.value || parentControl.invalid">
                                        <mat-icon [svgIcon]="'heroicons_outline:link'"></mat-icon>
                                        <span class="ml-2">Map</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Right Column: Mapped Destinations List -->
                        <div class="flex flex-col w-full lg:w-1/2">
                            <h3 class="text-lg font-bold mb-4">Mapped Destinations</h3>

                            <div class="flex flex-col border border-gray-300 dark:border-gray-700 rounded-2xl overflow-hidden bg-card shadow-sm h-[420px]">

                                <!-- Search Header -->
                                <div class="flex items-center px-4 py-3 border-b bg-gray-50 dark:bg-black/10">
                                    <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
                                    <input
                                        class="ml-3 flex-1 bg-transparent border-0 outline-none placeholder-secondary"
                                        type="text"
                                        placeholder="Filter by name, ID or state..."
                                        [formControl]="inputInternalSearchControl"
                                        [autocomplete]="'off'"
                                        (keyup)="searchMapList()"
                                        [maxLength]="50" />
                                </div>

                                <!-- Developer Details List Layout -->
                                <div class="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-50/50 dark:bg-transparent">
                                    <ng-container *ngIf="filteredMapList.length; else noMaps">
                                        <ng-container *ngFor="let mapElement of filteredMapList">

                                            <!-- Modern List Item Card -->
                                            <div class="flex flex-col sm:flex-row sm:items-start justify-between p-4 bg-card rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow transition-shadow">
                                                <div class="flex flex-col pr-4 mb-3 sm:mb-0">
                                                    <span class="text-base font-semibold">{{ mapElement.ds_destinationchild || mapElement.ds_name }}</span>

                                                    <!-- Developer Info Badges -->
                                                    <div class="flex flex-wrap items-center gap-2 mt-2">
                                                        <span class="px-2 py-1 text-xs font-mono font-medium rounded-md bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-400 border border-primary-200 dark:border-primary-800" matTooltip="Destination ID">
                                                            {{ mapElement.id_destination || mapElement.id_destinationdependency }}
                                                        </span>
                                                        <span *ngIf="mapElement.ds_en_state" class="px-2 py-1 text-xs font-medium rounded-md bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 border border-gray-200 dark:border-gray-700" matTooltip="State">
                                                            {{ mapElement.ds_en_state }}
                                                        </span>
                                                    </div>
                                                </div>

                                                <button mat-icon-button color="warn" class="shrink-0 self-end sm:self-center" (click)="deleteTag(mapElement.id_destinationdependency, 'id_destinationdependency')" matTooltip="Unmap Destination">
                                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                                </button>
                                            </div>

                                        </ng-container>
                                    </ng-container>
                                    <ng-template #noMaps>
                                        <div class="flex flex-col items-center justify-center h-full text-secondary opacity-70">
                                            <mat-icon class="icon-size-12 mb-2" [svgIcon]="'heroicons_outline:map'"></mat-icon>
                                            <span>No destinations mapped</span>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </ng-template>
        </div>

        <!-- Add Skin View -->
        <div class="flex justify-center items-center w-full px-4 mb-20" *ngIf="displayAddSkin" [@zoomIn]="displayAddSkin">
            <div class="flex flex-col flex-auto w-full max-w-xl mt-8">
                <fuse-card class="p-6 sm:p-10 rounded-2xl bg-card shadow-lg" [flippable]="true" [face]="'front'">
                    <ng-container fuseCardFront>

                        <fuse-alert class="mb-8" *ngIf="alert" [type]="alert.type" [showIcon]="false">
                            {{ alert.message }}
                        </fuse-alert>

                        <form class="flex flex-col gap-4" (ngSubmit)="createDestination()" [formGroup]="newDestinationForm">

                            <div class="mb-4">
                                <div class="text-3xl font-extrabold tracking-tight">Add New Skin</div>
                                <p class="text-secondary mt-1">Create a new destination mapping skin base.</p>
                            </div>

                            <mat-form-field class="w-full">
                                <mat-label>New Skin Name</mat-label>
                                <input formControlName="ds_name" placeholder="E.g. SummerPromo" matInput maxlength="14" (input)="onInputMaxReach($event, 15)" required>
                            </mat-form-field>

                            <mat-form-field class="w-full">
                                <mat-label>New Skin Endpoint</mat-label>
                                <input noSpacesNoSpecial placeholder="E.g. my-endpoint-url" formControlName="ds_url" matInput maxlength="14" (input)="onInputMaxReach($event, 15)" required>
                            </mat-form-field>

                            <mat-form-field class="w-full">
                                <mat-label>Original Skin to Copy</mat-label>
                                <input type="text"
                                       placeholder="Search original skin..."
                                       (blur)="onBlur()"
                                       (keyup)="keyUpAddSkin($event)"
                                       matInput [formControl]="parentControl"
                                       [matAutocomplete]="autoSkin">
                                <mat-autocomplete
                                    (optionSelected)="optionSelected($event)"
                                    #autoSkin="matAutocomplete"
                                    [displayWith]="displayFnSkin"
                                    autoActiveFirstOption="true">
                                    <mat-option *ngFor="let parent of filteredParents | async" [value]="parent" class="h-auto py-3">
                                        <div class="flex flex-col leading-tight">
                                            <span class="font-medium">{{ parent.ds_airline }}</span>
                                            <span class="text-sm font-mono text-secondary mt-1">ID: {{ parent.id_airline }}</span>
                                        </div>
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="parentControl.invalid && (parentControl.touched || parentControl.dirty)">
                                    Please select a valid Skin.
                                </mat-error>
                            </mat-form-field>

                            <!-- Form Actions -->
                            <div class="flex items-center justify-end gap-4 mt-4">
                                <button class="text-red-600" mat-button type="button" (click)="toggleAddSkin()">
                                    Cancel
                                </button>
                                <button
                                    [disabled]="!newDestinationForm.valid || !selectedMapElement"
                                    type="submit"
                                    mat-flat-button
                                    [color]="'primary'">
                                    Submit & Create
                                </button>
                            </div>
                        </form>
                    </ng-container>
                </fuse-card>
            </div>
        </div>

    </div>
</div>
